import React from "react";
import { getColor } from "../../themes";
import styles from "./Section.module.scss";

interface SectionProps {
    faIcon?: string;
    theme?: string;
    title?: string;
    className?: string;
}

export const Section: React.FC<SectionProps> = ({ className, faIcon, title, theme, children }) => {
    return (
        <div className={`section ${className ?? ""} ${styles.section}`}>
            <div className="header">
                {faIcon != null && faIcon.toString().trim() !== "" && (
                    <span
                        className={`${faIcon ?? ""} icon`}
                        style={{
                            ...(theme != null && theme.toString().trim() !== "" ? { color: getColor(theme) } : {})
                        }}
                    ></span>
                )}
                {title != null && title.toString().trim() !== "" && <div className="title">{title}</div>}
            </div>
            <hr
                style={{
                    ...(theme != null && theme.toString().trim() !== "" ? { background: getColor(theme) } : {})
                }}
                className={styles["defaultBar"]}
            ></hr>
            <div className="content">{children}</div>
        </div>
    );
};

export const SectionDemo = () => {
    return (
        <Section title="sss" faIcon="fa-light fa-square-info" theme="red">
            <div>www</div>
            <div>www</div>
        </Section>
    );
};
